<router-outlet></router-outlet>

<app-toast-container></app-toast-container>

<!-- filteredUrlPatterns matches every URL, so this no longer auto-shows for
     every in-flight HTTP request app-wide — it now only appears when code
     explicitly calls SpinnerVisibilityService.show()/hide(). -->
<ng-http-loader
  [backdrop]="true"
  [backgroundColor]="'#009A65'"
  [entryComponent]="spinnerComponent"
  [filteredUrlPatterns]="['.']">
</ng-http-loader>
